import { render, staticRenderFns } from "./HsfailureReport.vue?vue&type=template&id=371de7c3&"
import script from "./HsfailureReport.vue?vue&type=script&lang=js&"
export * from "./HsfailureReport.vue?vue&type=script&lang=js&"
import style0 from "./HsfailureReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports